import React from 'react';
import ReactGA from 'react-ga';
import './index.scss';
import { Dialog } from '../../components/Dialog';
import * as api from '../../services/api';
import en from '../../locales/en-US.json';
import zh from '../../locales/zh-Hans.json';
import urlparser from 'urlparser';
import { Button, Modal } from 'antd';
import InputEmail from '../../components/InputEmail/InputEmail';
import OpenSuccess from '../../components/InputEmail/OpenSuccess';


export interface IInviteSFProps {
  logo: string,
  inviterId: string;
  trailId: string;
  state:string;
}

interface IState {
  errMsg: string;
  showErr: boolean;
  email: string;
  lang: string;
  showDialog: boolean;
  message: any;
  jwt: string;
  time: string;
  custom: any;
  title: string;
  disabled: boolean;
  isWeChat: string;
  buttonUrl: string;
  logo: string;
  inviterId: string;
  trailId: string;
  showVip: string;
  inputEmail: boolean;
  openSuccess: boolean;
  state:string;
}

interface IParams {
  jwt: string;
  isWeChat: string;
  weChatButtonUrl: string;
  logo: string;
  inviterId: string;
}

export interface ITrialRes {
  time: number;
  error?: string;
  body?: {
    days: number;
  };
}

export class InviteSFPage extends React.Component<IInviteSFProps, IState> {
  public readonly state: Readonly<IState> = {
    errMsg: '',
    showErr: false,
    email: '',
    lang: 'zh-Hans',
    showDialog: false,
    message: {
      'zh-Hans': zh,
      'en-US': en
    },
    jwt: '',
    time: '',
    custom: '',
    title: '',
    disabled: false,
    isWeChat: '',
    buttonUrl: '',
    logo: '',
    inviterId: '',
    trailId: '',
    showVip: 'personal',
    inputEmail: false,
    openSuccess: false,
    state:''
  };

  UNSAFE_componentWillMount() {
    let url = urlparser.parse(window.location.href);
    let path = url.path.base;
    if (path.split('/')[1] === 'en') {
      this.setState({ lang: 'en-US' });
    }
  }

  componentDidMount() {
    this.setState(
      {
        trailId: this.props.trailId,
        logo: this.props.logo,
        inviterId: this.props.inviterId,
        state:this.props.state
      });
  }

  render() {
    const { showVip, inputEmail, openSuccess,trailId,inviterId,time,state } = this.state;
    return (
      <div className={'invite-sf'}>
        <img className={'bg-img'} src={require('../../assets/invite-sf/bg-1.png')}/>
        <div className={'vip'}>
          <img className={'bg-img'}
               src={showVip == 'enterprise' ? require('../../assets/invite-sf/bg-vip-2.png') : require('../../assets/invite-sf/bg-vip.png')}/>
          <div className={'btn-vip'}>
            <div onClick={() => this.setState({ showVip: 'personal' })}></div>
            <div onClick={() => this.setState({ showVip: 'enterprise' })}></div>
          </div>
        </div>
        <img className={'bg-img'} src={require('../../assets/invite-sf/bg-2.png')}/>
        <div className={'bottom-action'}>
          <Button className={'islide-button-red'} type={'primary'}
                  onClick={() => this.setState({ inputEmail: true })}>
            一键领取
          </Button>
        </div>
        <InputEmail visible={inputEmail} onClose={(e: any,time?:any) => {
          this.setState({ inputEmail: false });
          if (e === true) {
            ReactGA.pageview(window.location.pathname+`/${time}days/email/success`);
            this.setState({ openSuccess: true,time:time });
          }
        }} trailId={trailId} inviterId={inviterId} state={state}/>
        <OpenSuccess visible={openSuccess} time={time} onClose={() => this.setState({ openSuccess: false })}/>
      </div>
    );
  }
}
